import React from 'react';
import { hideDialog } from '../../base/dialog';
import { IconVideoBackground, IconClose } from '../../base/icons';

declare var APP: Object;

const _closeDialog = () => {
    APP.store.dispatch(hideDialog());
}

export const _customHeader = () => {
    return (
        <header>
            <h4>
                <IconVideoBackground />
                <span id="dialog-heading-1">Background</span>
            </h4>
            <div className="jitsi-icon" onClick={ _closeDialog }>
                <IconClose />
            </div>
        </header>
    )
}